import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useDoubt({ doubtId, enabled = true } = {}) {
  const { privateFetch } = useContext(FetchContext);

  const fetchDoubt = async () => {
    const response = await privateFetch.get(`/v1/admin/doubts/${doubtId}`);
    return response.data;
  };

  return useQuery(['single-doubt', doubtId], fetchDoubt, {
    enabled: enabled && !!doubtId,
    keepPreviousData: true,
  });
}

export default useDoubt;
